import { Icon } from '@iconify/react';
import homeFill from '@iconify/icons-eva/home-fill';
import fileFill from '@iconify/icons-eva/file-fill';
import roundGrain from '@iconify/icons-ic/round-grain';
import bookOpenFill from '@iconify/icons-eva/book-open-fill';
import infoFill from '@iconify/icons-eva/info-fill';
import mapFill from '@iconify/icons-eva/map-fill';
import navigation2Fill from '@iconify/icons-eva/navigation-2-fill';
// routes
import { PATH_AUTH, PATH_DOCS, PATH_PAGE, PATH_DASHBOARD } from '../../routes/paths';

// ----------------------------------------------------------------------

const ICON_SIZE = {
  width: 22,
  height: 22
};

const menuConfig = [
  {
    title: 'Home',
    icon: <Icon icon={homeFill} {...ICON_SIZE} />,
    path: '/'
  },
  {
    title: 'Services',
    path: '/services',
    icon: <Icon icon={fileFill} {...ICON_SIZE} />,
    children: [
      {
        subheader: 'Our Services',
        items: [
          { 
            title: 'Local Delivery', 
            path: '/services/local-delivery',
            icon: <Icon icon={navigation2Fill} width={24} height={24} />,
            description: 'Fast, on-demand local deliveries across the city.'
          },
          { 
            title: 'National Delivery', 
            path: '/services/national-delivery',
            icon: <Icon icon={mapFill} width={24} height={24} />,
            description: 'Reliable nationwide logistics connecting states.'
          },
        ]
      }
    ]
  },
  {
    title: 'About Us',
    icon: <Icon icon={infoFill} {...ICON_SIZE} />,
    path: '/about-us'
  }
];

export default menuConfig;
